import React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Typography, Box } from "@material-ui/core";
import WelcomeMessage from "../WelcomeMessage/WelcomeMessage";
import { useStyles } from './Styles';
//import "./HomePage.css";

const HomePage = () => {
    const { t } = useTranslation();
    const isLoggingIn = useSelector(state => state.authentication.isLoggingIn);
    const classes = useStyles();

    return (
        <Box className={classes.homepage}>
            <WelcomeMessage />
            {isLoggingIn ? (
                <h2>{t("HomePage.signingIn")}</h2>
            ) : (
                <React.Fragment>
                        <img className={classes.homepageLogo} src="/resources/HomePageLogo.png" alt="" />
                        <Typography variant="h2" className={classes.homepageTitle}>
                        {t("HomePage.title")}
                    </Typography>
                </React.Fragment>
            )}
        </Box>
    );
};

export default HomePage;
